// extracted by mini-css-extract-plugin
export var chip = "_c4-0";
export var filterDropdown = "_c4-5";
export var filterItem = "_c4-6";
export var icon = "_c4-1";
export var removeButton = "_c4-3";
export var removeIcon = "_c4-4";
export var separator = "_c4-2";